import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const MENTOR = 'mentor'
const ACADEMIC_YEAR = 'academic_year'
const GRADE_LEVEL = 'grade_level'
const SIGN = 'sign'

/**
 * Form model
 */
const formModel = () => {
  return {
    [MENTOR]: {
      label: `${t('common.mentor')}`,
      name: MENTOR,
      required: true,
    },
    [ACADEMIC_YEAR]: {
      label: `${t('common.academic-year')}`,
      name: ACADEMIC_YEAR,
      required: true,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
      required: true,
    },
    [SIGN]: {
      label: `${t('common.sign')}`,
      name: SIGN,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [MENTOR]: null,
  [ACADEMIC_YEAR]: null,
  [GRADE_LEVEL]: null,
  [SIGN]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [MENTOR]: yup
       .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [ACADEMIC_YEAR]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [GRADE_LEVEL]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [SIGN]: yup
      .string()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
